<template lang="html">
  <div class="card-base card-shadow--small p-20 h-100 ">
    <el-row :gutter="24">
      <el-col :span="24" :offset="0">
        <el-row :gutter="10">
          <el-col :lg="3" :md="4" :offset="0">
            <el-input-number 
              v-model="quantity" label="Cantidad"
              :min="0" :step="1" :controls="true" controls-position="both"
            >
            </el-input-number>
          </el-col>
          <el-col :span="7" :offset="0">
            <product-autocomplete-component ref="productAutocomplete" @select="setCode" @clear="setCode"/>
          </el-col>
          <el-col :lg="2" :md="3" :offset="0">
            <el-button :disabled="!code" @click="validateProduct()" type="success" icon="el-icon-plus" :loading="loading">Agregar</el-button>
          </el-col>
          <el-col :lg="12" :md="10">
            <el-input type="text" placeholder="Observación" v-model="observation"></el-input>
          </el-col>
        </el-row>
        <el-divider/>
        <el-table :data="detail" class="w-100" height="470">
          <el-empty slot="empty" description="No hay datos"></el-empty>
          <el-table-column
            prop="code"
            label="Código"
            width="240">
          </el-table-column>
          <el-table-column
            prop="description"
            label="Descrpción">
          </el-table-column>
          <el-table-column
            prop="quantity"
            label="Cantidad"
            width="200">
          </el-table-column>
          <el-table-column
            prop="actioions"
            label="Acciones"
            width="180">
            <template slot-scope="scope">
              <el-popconfirm
                confirm-button-text='Confirmar'
                cancel-button-text='Cancelar'
                icon="el-icon-info"
                icon-color="red"
                title="Confirmar eliminación"
                @confirm="deleteRow(detail[scope.$index])"
              >
                <el-button
                  slot="reference"
                  type="danger"
                  plain
                  round
                  size="mini" icon="el-icon-delete">
                </el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import ProductAutocompleteComponent from '@/views/pages/product/Autocomplete.vue'
export default {
  components: { ProductAutocompleteComponent },
  data: () => {
    return {
      loading: false,
      quantity: 1,
      code: null,
    };
  },
  computed: {
    ...mapGetters(['document','response', 'detail']),
    observation: {
      get() { return this.document.observation },
      set (value) { this['inputAndOutputAdjust/SET_OBSERVATION'](value) }
    }
  },
  methods: {
    ...mapMutations(['inputAndOutputAdjust/SET_OBSERVATION']),
    ...mapActions([
      'inputAndOutputAdjust/addProductAction',
      'inputAndOutputAdjust/deleteRowAction',
    ]),
    setCode(item){ (item ) ? this.code = item.codigo : null },
    validateProduct() {
      if (!this.code)
        return;
      
      this.loading = true;
      this['inputAndOutputAdjust/addProductAction']({
        code: this.code,
        quantity: this.quantity,
        type: this.$route.meta.type,
        typeDocument: this.$route.meta.typeDocument
      })
      this.$refs.productAutocomplete.reset()
      this.code = null;
      this.quantity = 1
      this.loading = false;
    },
    deleteRow(row) {
      this['inputAndOutputAdjust/deleteRowAction'](row)
    },
  },
};
</script>